import { render } from "./EffectsLayer.vue?vue&type=template&id=5bbee4ef&scoped=true"
import script from "./EffectsLayer.vue?vue&type=script&lang=js"
export * from "./EffectsLayer.vue?vue&type=script&lang=js"

import "./EffectsLayer.vue?vue&type=style&index=0&id=5bbee4ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbee4ef"]])

export default __exports__